import React, { useEffect } from "react";
import { connect } from "react-redux";
import dynamic from "@redux-dynostore/react-redux";
import subspaced from "@redux-dynostore/react-redux-subspace";
import { attachReducer } from "@redux-dynostore/redux-subspace";
import {
  mapStateToProps,
  passwordRecoveryReducer,
  mapDispatchToProps,
} from "./PasswordRecovery.store";
import PasswordRecovery from "../../library/PasswordRecovery/PasswordRecovery";

export const SmartPasswordRecovery = (props) => {
  const {
    recover,
    resetSubmitState,
    onDone,
    submittedRecover,
    errorMessage,
    resetErrorMessage,
    loginUsername,
  } = props;

  useEffect(() => {
    return () => {
      resetSubmitState();
      resetErrorMessage();
    };
  }, [resetSubmitState]);

  return (
    <PasswordRecovery
      submittedRecover={submittedRecover}
      onRecover={recover}
      onDone={onDone}
      errorMessage={errorMessage}
      loginUsername={loginUsername}
    />
  );
};

export default dynamic(
  "passwordRecoveryReducer",
  subspaced({
    mapExtraState: (state) => ({
      recoveryReducer: state.recoveryReducer,
      loginReducer: state.loginReducer,
    }),
  }),
  attachReducer(passwordRecoveryReducer)
)(connect(mapStateToProps, mapDispatchToProps)(SmartPasswordRecovery));
